import "core-js/stable"
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'ant-design-vue/dist/antd.css';
import {Input, Checkbox, Button, Modal, Spin, Tree, Pagination, ConfigProvider, Icon, message} from 'ant-design-vue'

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
Vue.prototype.$layer = layer(Vue);

Vue.prototype.$message = message
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Spin)
Vue.use(Tree)
Vue.use(Pagination)
Vue.use(ConfigProvider)
Vue.use(Icon)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
